import * as React from 'react';
import { forwardRef, KeyboardEventHandler, MutableRefObject, useCallback, useRef } from 'react';

import cx from 'clsx';

import { mergeRefs, MixProps } from '../..';
import { FocusLock } from '../../src/components/Other/FocusLock';
import { useOnClickOutside } from '../../src/hooks/useOnClickOutside';

type DayPickerInputWrapperProps = MixProps<{
  isOpen: boolean;
  portaledElementRef?: MutableRefObject<HTMLDivElement | null>;
  onDayPickerClose(): void;
}>;

export const DayPickerInputWrapper = forwardRef<HTMLDivElement, DayPickerInputWrapperProps>(
  ({ children, className, onDayPickerClose, isOpen, portaledElementRef, ...props }, ref) => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const mergedRef = mergeRefs<HTMLDivElement>([wrapperRef, ref]);

    useOnClickOutside({ ref: wrapperRef, isEnabled: isOpen, handler: onDayPickerClose, portaledElementRef });

    const onKeyDown = useCallback<KeyboardEventHandler<HTMLDivElement>>(
      (e) => {
        if (e.key === 'Escape') {
          onDayPickerClose();
        }

        props.onKeyDown?.(e);
      },
      [props.onKeyDown, onDayPickerClose]
    );

    return (
      <FocusLock autoFocus={false} disabled={!isOpen} shards={portaledElementRef ? [portaledElementRef] : undefined}>
        <div {...props} onKeyDown={onKeyDown} className={cx('d-flex flex-column', className)} ref={mergedRef}>
          {children}
        </div>
      </FocusLock>
    );
  }
);

DayPickerInputWrapper.displayName = 'DayPickerInputWrapper';
